// import React from "react";

// function ContactForm() {
//   return (
//     <div className="contact-form-area pb-5">
//       <div className="container">
//         <div className="row justify-content-center">
//           <div className="col-lg-10">
//             <div className="contact-form-wrapper" style={{
//               background: "rgba(255, 255, 255, 0.7)",
//               backdropFilter: "blur(20px)",
//               WebkitBackdropFilter: "blur(20px)",
//               border: "1px solid rgba(255, 255, 255, 0.3)",
//               borderRadius: "30px",
//               padding: "50px",
//               boxShadow: "0 20px 50px rgba(0, 0, 0, 0.05)",
//               marginTop: "-60px",
//               position: "relative",
//               zIndex: 2
//             }}>
//               <form>
//                 <div className="row">
//                   <div className="col-md-6 mb-4">
//                     <div className="form-group">
//                       <label className="fw-bold mb-2 ps-1" style={{ fontSize: "14px", color: "#4b5563" }}>Full Name</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="John Doe"
//                         style={{
//                           height: "60px",
//                           borderRadius: "15px",
//                           border: "1px solid #e5e7eb",
//                           padding: "0 25px",
//                           fontSize: "16px",
//                           background: "#ffffff",
//                           transition: "all 0.3s ease"
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6 mb-4">
//                     <div className="form-group">
//                       <label className="fw-bold mb-2 ps-1" style={{ fontSize: "14px", color: "#4b5563" }}>Email Address</label>
//                       <input
//                         type="email"
//                         className="form-control"
//                         placeholder="john@example.com"
//                         style={{
//                           height: "60px",
//                           borderRadius: "15px",
//                           border: "1px solid #e5e7eb",
//                           padding: "0 25px",
//                           fontSize: "16px",
//                           background: "#ffffff",
//                           transition: "all 0.3s ease"
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6 mb-4">
//                     <div className="form-group">
//                       <label className="fw-bold mb-2 ps-1" style={{ fontSize: "14px", color: "#4b5563" }}>Subject</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="Project Inquiry"
//                         style={{
//                           height: "60px",
//                           borderRadius: "15px",
//                           border: "1px solid #e5e7eb",
//                           padding: "0 25px",
//                           fontSize: "16px",
//                           background: "#ffffff",
//                           transition: "all 0.3s ease"
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6 mb-4">
//                     <div className="form-group">
//                       <label className="fw-bold mb-2 ps-1" style={{ fontSize: "14px", color: "#4b5563" }}>Phone (Optional)</label>
//                       <input
//                         type="text"
//                         className="form-control"
//                         placeholder="+1 (555) 000-0000"
//                         style={{
//                           height: "60px",
//                           borderRadius: "15px",
//                           border: "1px solid #e5e7eb",
//                           padding: "0 25px",
//                           fontSize: "16px",
//                           background: "#ffffff",
//                           transition: "all 0.3s ease"
//                         }}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-12 mb-4">
//                     <div className="form-group">
//                       <label className="fw-bold mb-2 ps-1" style={{ fontSize: "14px", color: "#4b5563" }}>Your Message</label>
//                       <textarea
//                         className="form-control"
//                         placeholder="Tell us about your project or inquiry..."
//                         rows="5"
//                         style={{
//                           borderRadius: "15px",
//                           border: "1px solid #e5e7eb",
//                           padding: "20px 25px",
//                           fontSize: "16px",
//                           background: "#ffffff",
//                           transition: "all 0.3s ease",
//                           resize: "none"
//                         }}
//                       ></textarea>
//                     </div>
//                   </div>
//                   <div className="col-12 text-center mt-3">
//                     <button type="submit" className="btn px-5 py-3" style={{
//                       borderRadius: "50px",
//                       background: "linear-gradient(90deg, #673AB7, #2196F3)",
//                       color: "#ffffff",
//                       fontWeight: "700",
//                       fontSize: "16px",
//                       border: "none",
//                       boxShadow: "0 10px 20px rgba(103, 58, 183, 0.2)",
//                       transition: "all 0.3s ease",
//                       cursor: "pointer"
//                     }}>
//                       Send Message ↗
//                     </button>
//                   </div>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ContactForm;

"use client";

import React, { useState } from "react";

function ContactForm() {
  const [loading, setLoading] = useState(false);

  const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: "",
  });

  // ================= POPUP =================

  const showPopup = (type, message) => {
    setPopup({ show: true, type, message });

    setTimeout(() => {
      setPopup({ show: false, type: "", message: "" });
    }, 3000);
  };

  // ================= SUBMIT =================

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const name = formData.get("name")?.trim() || "";
    const rawEmail = formData.get("email") || "";
    const rawPhone = formData.get("phone") || "";
    const subject = formData.get("subject") || "";
    const message = formData.get("message")?.trim() || "";

    const email = rawEmail.trim().toLowerCase();
    const phone = rawPhone.replace(/\D/g, "").slice(-10);

    // ================= VALIDATION =================

    if (!name || name.length < 2) {
      return showPopup("error", "Please enter your name");
    }

    if (!email) {
      return showPopup("error", "Please enter your email");
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      return showPopup("error", "Enter valid email");
    }

    if (!phone) {
      return showPopup("error", "Please enter mobile number");
    }

    if (!/^[6-9]\d{9}$/.test(phone)) {
      return showPopup("error", "Enter valid 10-digit mobile number");
    }

    if (!message) {
      return showPopup("error", "Enter project details");
    }

    // ================= API CALL =================

    try {
      setLoading(true);

      await fetch(
        "https://script.google.com/macros/s/AKfycbzWtv_L5Yr--Z5P7XLuVHzvj202d59HVpHGvIugwYlaOwUy76BkirZFw2qzD251IAiMFQ/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            email,
            phone,
            subject,
            message,
          }),
        },
      );

      e.target.reset();

      showPopup("success", "Message sent successfully 🚀");
    } catch (err) {
      console.error(err);

      showPopup("error", "Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="contact-form-area pb-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div
              className="contact-form-wrapper"
              style={{
                background: "rgba(255, 255, 255, 0.7)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                borderRadius: "30px",
                padding: "50px",
                boxShadow: "0 20px 50px rgba(0, 0, 0, 0.05)",
                marginTop: "-60px",
                position: "relative",
                zIndex: 2,
              }}
            >
              {/* ================= POPUP ================= */}

              {popup.show && (
                <div
                  style={{
                    position: "fixed",
                    top: "30px",
                    right: "30px",
                    zIndex: 99999,
                    padding: "14px 22px",
                    borderRadius: "14px",
                    background:
                      popup.type === "success"
                        ? "linear-gradient(90deg,#2196F3,#673AB7)"
                        : "#ef4444",
                    color: "#fff",
                    fontWeight: 600,
                    boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
                  }}
                >
                  {popup.message}
                </div>
              )}

              {/* ================= FORM ================= */}

              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* FULL NAME */}

                  <div className="col-md-6 mb-4">
                    <div className="form-group">
                      <label
                        className="fw-bold mb-2 ps-1"
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                        }}
                      >
                        Full Name
                      </label>

                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="John Doe"
                        style={{
                          height: "60px",
                          borderRadius: "15px",
                          border: "1px solid #e5e7eb",
                          padding: "0 25px",
                          fontSize: "16px",
                          background: "#ffffff",
                          transition: "all 0.3s ease",
                        }}
                      />
                    </div>
                  </div>

                  {/* EMAIL */}

                  <div className="col-md-6 mb-4">
                    <div className="form-group">
                      <label
                        className="fw-bold mb-2 ps-1"
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                        }}
                      >
                        Email Address
                      </label>

                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="john@example.com"
                        style={{
                          height: "60px",
                          borderRadius: "15px",
                          border: "1px solid #e5e7eb",
                          padding: "0 25px",
                          fontSize: "16px",
                          background: "#ffffff",
                          transition: "all 0.3s ease",
                        }}
                      />
                    </div>
                  </div>

                  {/* SUBJECT */}

                  <div className="col-md-6 mb-4">
                    <div className="form-group">
                      <label
                        className="fw-bold mb-2 ps-1"
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                        }}
                      >
                        Subject
                      </label>

                      <input
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Project Inquiry"
                        style={{
                          height: "60px",
                          borderRadius: "15px",
                          border: "1px solid #e5e7eb",
                          padding: "0 25px",
                          fontSize: "16px",
                          background: "#ffffff",
                          transition: "all 0.3s ease",
                        }}
                      />
                    </div>
                  </div>

                  {/* PHONE */}

                  <div className="col-md-6 mb-4">
                    <div className="form-group">
                      <label
                        className="fw-bold mb-2 ps-1"
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                        }}
                      >
                        Phone (Optional)
                      </label>

                      <input
                        type="text"
                        name="phone"
                        className="form-control"
                        placeholder="+1 (555) 000-0000"
                        style={{
                          height: "60px",
                          borderRadius: "15px",
                          border: "1px solid #e5e7eb",
                          padding: "0 25px",
                          fontSize: "16px",
                          background: "#ffffff",
                          transition: "all 0.3s ease",
                        }}
                      />
                    </div>
                  </div>

                  {/* MESSAGE */}

                  <div className="col-12 mb-4">
                    <div className="form-group">
                      <label
                        className="fw-bold mb-2 ps-1"
                        style={{
                          fontSize: "14px",
                          color: "#4b5563",
                        }}
                      >
                        Your Message
                      </label>

                      <textarea
                        name="message"
                        className="form-control"
                        placeholder="Tell us about your project or inquiry..."
                        rows="5"
                        style={{
                          borderRadius: "15px",
                          border: "1px solid #e5e7eb",
                          padding: "20px 25px",
                          fontSize: "16px",
                          background: "#ffffff",
                          transition: "all 0.3s ease",
                          resize: "none",
                        }}
                      ></textarea>
                    </div>
                  </div>

                  {/* BUTTON */}

                  <div className="col-12 text-center mt-3">
                    <button
                      type="submit"
                      disabled={loading}
                      className="btn px-5 py-3"
                      style={{
                        borderRadius: "50px",
                        background: "linear-gradient(90deg, #673AB7, #2196F3)",
                        color: "#ffffff",
                        fontWeight: "700",
                        fontSize: "16px",
                        border: "none",
                        boxShadow: "0 10px 20px rgba(103, 58, 183, 0.2)",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                      }}
                    >
                      {loading ? "Sending..." : "Send Message ↗"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
